import { RefreshIcon } from '@heroicons/react/outline';
import { Button } from 'components/atoms/Button';
import { Select } from 'components/atoms/Form/Select';
import { Title } from 'components/atoms/Title';
import { SizesEnum } from 'components/atoms/Title/Title.enum';
import type { FC } from 'react';
import { ExclamationCircleIconOutline } from 'utils/icons';

const ENVSwitcher: FC<{
  envName: string;
  setEnvName: (env: string) => void;
}> = ({ envName, setEnvName }) => {
  const switchEnv = (env: string) => {
    const prefix = env === 'production' ? 'https://' : `https://${env}.`;

    localStorage.setItem(
      'customENV',
      JSON.stringify({
        baseUrl: `${prefix}app.accountable.eu/api`,
        filesUrl: `${prefix}files.accountable.eu`,
        redirectUrl: `${prefix}accountable.app.link/user_access`,
      }),
    );
    window.location.reload();
  };

  return (
    <div className="mb-6">
      <div className="flex items-center mb-4 gap-6">
        <Title type={SizesEnum.h6}>Switch backend server</Title>
        <Button
          structure="text"
          className=""
          onClick={() => {
            localStorage.removeItem('customENV');
            window.location.reload();
          }}
        >
          <RefreshIcon className="w-4 h-4" />
          <span className="pl-2">Reset default</span>
        </Button>
      </div>
      <div className="w-[70%]">
        <Select
          name="env"
          onChange={(env) => {
            setEnvName(env?.id);
            switchEnv(env?.id);
          }}
          value={envName}
          options={[
            {
              id: 'staging',
              label: 'Staging',
              checked: envName === 'staging',
            },
            {
              id: 'helium',
              label: 'Helium',
              checked: envName === 'helium',
            },
            {
              id: 'hydrogen',
              label: 'Hydrogen',
              checked: envName === 'hydrogen',
            },
            {
              id: 'carbon',
              label: 'Carbon',
              checked: envName === 'carbon',
            },
            {
              id: 'xenon',
              label: 'Xenon',
              checked: envName === 'xenon',
            },
            {
              id: 'krypton',
              label: 'Krypton',
              checked: envName === 'krypton',
            },
            {
              id: 'oxygen',
              label: 'Oxygen',
              checked: envName === 'oxygen',
            },
            {
              id: 'iron',
              label: 'Iron',
              checked: envName === 'iron',
            },
            {
              id: 'neon',
              label: 'Neon',
              checked: envName === 'neon',
            },
            {
              id: 'qa',
              label: 'QA',
              checked: envName === 'qa',
            },
            {
              id: 'production',
              label: 'Production',
              checked: envName === 'app',
              InfoComponent: () => (
                <ExclamationCircleIconOutline className="w-4 h-4 ml-1 text-red-500" />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default ENVSwitcher;
